if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const spinner = opener.querySelector && opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          // Single-variant products have no variant picker: add straight to cart, no modal.
          const hasPicker = this.productElement && this.productElement.querySelector('variant-radios,variant-selects');
          if (!hasPicker) {
            const idInput = this.productElement && this.productElement.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
            if (idInput && idInput.value) {
              return this._directAddToCart(opener, idInput.value);
            }
          }

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          this.interceptAddToCart();
          super.show(opener);
        })
        .catch((err) => {
          console.error('Quick add modal failed:', err);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          const spinner = opener.querySelector && opener.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    _directAddToCart(opener, variantId) {
      opener.setAttribute('aria-disabled', 'true');
      opener.classList.add('loading');
      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', 'cart-icon-bubble');

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status >= 400) throw new Error(data.description || data.message || 'Add to cart failed');
        this._updateCartBubble(data);
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        const label = opener.querySelector('span');
        const originalText = label ? label.textContent : opener.textContent;
        if (label) label.textContent = '✓ Added to cart';
        opener.style.background = '#428445';
        opener.style.borderColor = '#428445';
        opener.style.color = '#fff';
        opener.style.transition = 'all 0.3s ease';
        setTimeout(() => {
          if (label) label.textContent = originalText;
          opener.style.background = '';
          opener.style.borderColor = '';
          opener.style.color = '';
          opener.removeAttribute('aria-disabled');
        }, 1800);
      })
      .catch(err => {
        console.error('Quick add failed:', err);
        opener.removeAttribute('aria-disabled');
      })
      .finally(() => {
        opener.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
    }

    _updateCartBubble(data) {
      if (data.sections && data.sections['cart-icon-bubble']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        const newBubble = doc.querySelector('.cart-count-bubble');
        const existingBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (newBubble && existingBubble) {
          existingBubble.innerHTML = newBubble.innerHTML;
        } else if (newBubble) {
          const iconWrap = document.querySelector('#cart-icon-bubble');
          if (iconWrap) iconWrap.appendChild(newBubble);
        }
      }
    }

    interceptAddToCart() {
      const form = this.modalContent.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      // Change form to not trigger native submit — use click on button instead
      const submitBtn = form.querySelector('[name="add"]');
      if (submitBtn) {
        submitBtn.setAttribute('type', 'button');
        submitBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          this._doAddToCart(form, submitBtn);
        });
      }
    }

    _doAddToCart(form, submitBtn) {
      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
        const spinner = submitBtn.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }

      const formData = new FormData(form);
      formData.append('sections', 'cart-icon-bubble');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status >= 400) throw new Error(data.description || data.message || 'Add to cart failed');
        this._updateCartBubble(data);
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
          const spinner = submitBtn.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
          if (submitBtn.querySelector('span')) {
            submitBtn.querySelector('span').textContent = '✓ Added to cart';
          }
          submitBtn.style.background = '#428445';
          submitBtn.style.borderColor = '#428445';
          submitBtn.style.color = '#fff';
          submitBtn.style.transition = 'all 0.3s ease';
        }
        setTimeout(() => { this.hide(); }, 1000);
      })
      .catch(err => {
        console.error('Quick add failed:', err);
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
          const spinner = submitBtn.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const picker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (picker) picker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      if (!product) return;
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
